import { apiClient } from '../../../../api/axios';
import type { ApiResponse, PaginatedMetadata } from '../common/types';
import type { InstitutionItem, CreateUpdateInstitutionPayload, GetInstitutionsPayload } from './types';

export const institutionService = {
  getInstitutions: async (
    payload: GetInstitutionsPayload
  ): Promise<ApiResponse<PaginatedMetadata<InstitutionItem>>> => {
    const response = await apiClient.post(
      '/Institutions/GetInstitutions',
      payload
    );
    return response.data;
  },

  createUpdateInstitution: async (
    payload: CreateUpdateInstitutionPayload
  ): Promise<ApiResponse<InstitutionItem>> => {
    const response = await apiClient.post('/Institutions/CreateInstitution', payload);
    return response.data;
  },

  updateInstitution: async (
    payload: CreateUpdateInstitutionPayload
  ): Promise<ApiResponse<InstitutionItem>> => {
    const response = await apiClient.post('/Institutions/UpdateInstitution', payload);
    return response.data;
  },
};
